/*
 *
 * ChannelsPage reducer
 *
 */

import {
  SET_CLIENT_FILTER,
  SET_STATUS_FILTER,
  FETCH_CHANNELS_SUCCESS,
  FETCH_CHANNELS_REQUEST,
  POST_CHANNEL_REQUEST,
  PUT_CHANNEL_SUCCESS,
  FETCH_CLIENTS_SUCCESS,
  PATCH_CHANNEL_REQUEST,
  PATCH_CHANNEL_SUCCESS,
  CHANGE_TAB,
  FETCH_CHANNELS_FAILURE,
  PUT_CHANNEL_FAILURE,
  FETCH_THEMES_SUCCESS,
  FETCH_MODES_SUCCESS,
  DELETE_CHANNEL_SUCCESS,
  FETCH_CHANNEL_DETAIL_REQUEST,
  FETCH_UPDATED_CHANNEL_DETAIL_REQUEST,
  FETCH_CHANNEL_DETAIL_SUCCESS,
  FETCH_SLUG_VALIDATE_REQUEST,
  FETCH_SLUG_VALIDATE_SUCCESS,
  FETCH_SLUG_VALIDATE_FAILURE,
} from './constants';
import { toNumber } from 'utils/helpers'

const initialState = {
  clientFilter: "",
  statusFilter: "active",
  allChannels: null,
  channelDetail: null,
  isFetching: false,
  clients: {},
  currentTab: 0,
  channelThemes: {},
  modes: {},
  channelThemeInstances: {},
  paging: {},
  errors: null,
  isSaving: false,
  validSlug: true,
  slugIsValidating: false,
};

function channelsPageReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CLIENT_FILTER:
      return {
        ...state,
        clientFilter: action.payload,
      };
    case SET_STATUS_FILTER:
      return {
        ...state,
        statusFilter: action.payload,
      };
    case PATCH_CHANNEL_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case FETCH_SLUG_VALIDATE_REQUEST:
      return {
        ...state,
        slugIsValidating: true,
      };
    case FETCH_SLUG_VALIDATE_SUCCESS:   
      if (action.payload === 404) {
        return {
          ...state,
          slugIsValidating: false,
          validSlug: true,
        }
      }
        return {
          ...state,
          slugIsValidating: false,
          validSlug: false,
        };
    case FETCH_SLUG_VALIDATE_FAILURE:
        return {
          ...state,
          isFetching: false,
          slugIsValidating: false,
          validSlug: false,
        };
    case POST_CHANNEL_REQUEST:
    case FETCH_CHANNELS_REQUEST:
    case FETCH_UPDATED_CHANNEL_DETAIL_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_CHANNEL_DETAIL_REQUEST:
      return {
        ...state,
        channelDetail: null,
        isFetching: true,
      };
    case FETCH_CHANNELS_SUCCESS:
      const { payload } = action;
      return {
        ...state,
        isFetching: false,
        allChannels: payload.data,
        paging: {
          currentPage: toNumber(payload.current_page),
          rowsPerPage: toNumber(payload.rows_per_page),
          pageCount: toNumber(payload.page_count),
        },
        errors: null,
      }
    case FETCH_CHANNEL_DETAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        channelDetail: action.payload,
      }
    case PATCH_CHANNEL_SUCCESS:
      return {
        ...state,
        isSaving: false,
      }
    case PUT_CHANNEL_SUCCESS:
    case FETCH_CLIENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        clients: {
          ...state.clients,
          ...action.payload.clients,
        },
        channelThemeInstances: {
          ...state.allChannels,
          ...action.payload.channelThemeInstances,
        },
        errors: null,
      };
    case FETCH_THEMES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        channelThemes: {
          ...action.payload.channelThemes,
        },
      };
    case FETCH_MODES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        modes: {
          ...action.payload.modes,
        },
      };
    case FETCH_CHANNELS_FAILURE:
    case PUT_CHANNEL_FAILURE:
      return {
        ...state,
        isFetching: false,
        errors: action.payload.errors || "Something went wrong",
        isSaving: false,
      };
    case CHANGE_TAB:
      return {
        ...state,
        currentTab: action.payload !== undefined ? action.payload : state.currentTab + 1,
      };
    case DELETE_CHANNEL_SUCCESS:
      return {
        ...state,
        allChannels: state.allChannels.filter(item => item.id !== action.payload.channelId),
      };
    default:
      return state;
  }
}

export default channelsPageReducer;



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/reducer.js